// extracted by mini-css-extract-plugin
export default {"sparkChartContainer":"SparkChart_sparkChartContainer__NyUQN","sparkChartDomElement":"SparkChart_sparkChartDomElement__T9ITP"};